import { Centrifuge } from 'centrifuge';
import axios from 'axios';
import { ref } from 'vue';

export class ScCentrifuge {
    centrifuge = null;
    connectionToken = ref(null);

    constructor (token) {
        this.connectionToken.value = token || window.bcToken;
        const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
        this.centrifuge = new Centrifuge(`${protocol}://${window.location.host}/connection/websocket`, {
            token: this.connectionToken.value,
            getToken: async (ctx) => {
                try {
                    const resp = await axios.post('/broadcasting/connect', ctx);
                    this.connectionToken.value = resp.data.token;
                    console.log('connect', resp);
                    return resp.data.token;
                } catch (e) {
                    console.log(e);
                }
            },
        });
        this.centrifuge.connect();
    }

    async getSubscriptionToken(ctx) {
        try {
            const resp = await axios.post('/broadcasting/auth', ctx);
            return resp.data.token;
        } catch (e) {
            console.log(e);
            if (e.response && e.response.status === 403) {
                return '';
            }

            throw e;
        }
    }

    newSubscription (name, options) {
        const subscriptionOptions = {...options};

        // Inget behov av subscription token för user channels, men bör kunna hanteras snyggare?
        if (name.indexOf('#') === -1) {
            subscriptionOptions.getToken = (ctx) => this.getSubscriptionToken(ctx);
        }

        return this.centrifuge.newSubscription(name, {
            ...subscriptionOptions,
        });
    }
}

export const centrifuge = new ScCentrifuge();

